// extracted by mini-css-extract-plugin
export default {"navItem":"Nav_navItem__wPW8B","lightNavLink":"Nav_lightNavLink__O8Tsm","active":"Nav_active__3h2eF","darkNavLink":"Nav_darkNavLink__IPgcz"};